export const FAQ_PATH = "/faq"

/** Short guide sections for features that have their own settings screen. */
export const FAQ_FEATURE_SECTION_IDS = [
  "ai-antispam",
  "chat-cleanup",
  "reports",
  "event-log",
  "ai-training",
  "ai-learning",
  "support-mode",
  "business-mode",
  "clones",
  "grid",
  "plans",
  "api-key"
] as const

// Bot messages link here as startapp=tab=faq-<id>; keep the ids stable once shipped.
export const FAQ_SECTION_IDS = [
  "basics",
  "entertainment",
  "ai",
  "moderation-functions",
  "moderation-commands",
  "rating",
  ...FAQ_FEATURE_SECTION_IDS
] as const

export type FaqSectionId = (typeof FAQ_SECTION_IDS)[number]

export type FaqFeatureSectionId = (typeof FAQ_FEATURE_SECTION_IDS)[number]

const FAQ_TAB = "faq"
const FAQ_SECTION_TAB_PREFIX = `${FAQ_TAB}-`

const isFaqSectionId = (value: string): value is FaqSectionId => FAQ_SECTION_IDS.some(id => id === value)

const buildFaqSectionPath = (section: FaqSectionId): string => `${FAQ_PATH}/${section}`

export const isFaqDeepLinkTab = (tab: string): boolean => tab === FAQ_TAB || tab.startsWith(FAQ_SECTION_TAB_PREFIX)

/** Unknown sections fall back to the guide index so an outdated bot link still opens the FAQ. */
export const resolveFaqDeepLinkPath = (tab: string): string => {
  const section = tab.slice(FAQ_SECTION_TAB_PREFIX.length)
  return tab.startsWith(FAQ_SECTION_TAB_PREFIX) && isFaqSectionId(section) ? buildFaqSectionPath(section) : FAQ_PATH
}
